<template>
  <el-dialog
    :visible="mState"
    title="冒险勋章兑换方法"
    @close='closeFn'
    width="45%" center>
    <ol>
      <li>
        <h3>1、通过活动页面绑定移动手机号，同一迷你号可绑定多个移动手机号</h3>
      </li>
      <li>
        <h3>2、绑定手机在移动积分平台兑换的“冒险勋章”可返回本活动页面点击“查询冒险勋章”按钮进行提取</h3>
      </li>
      <li>
        <h3>3、若忘记中国移动客服密码，可采用更便捷的短信兑换方式</h3>
        <p style='color: #f00;'>具体兑换方式如下：(发送及接收短信免费)</p>
        <p>迷你世界冒险勋章5个 100积分</p>
        <p>编辑短信内容 DH758721 发送到 10658999</p>
        <p>迷你世界冒险勋章10个 200积分</p>
        <p>编辑短信内容 DH758722 发送到 10658999</p>
        <p>迷你世界冒险勋章20个 400积分</p>
        <p>编辑短信内容 DH759023 发送到 10658999</p>
        <p>迷你世界冒险勋章 50个 600积分</p>
        <p>编辑短信内容 DH759123 发送到 10658999</p>
        <p>迷你世界冒险勋章70个 800积分</p>
        <p>编辑短信内容 DH759124 发送到 10658999</p>
        <p>迷你世界冒险勋章 100个 1000积分</p>
        <p>编辑短信内容 DH759125 发送到 10658999</p>
        <p>迷你世界冒险勋章 200个 2000积分</p>
        <p>编辑短信内容 DH759126 发送到 10658999</p>
        <p>迷你世界冒险勋章 300个 3000积分</p>
        <p>编辑短信内容 DH759127 发送到 10658999</p>
        <p>迷你世界冒险勋章 500个 4990积分</p>
        <p>编辑短信内容 DH759015 发送到 10658999</p>
        <p>根据短信提示兑换完成后，返回本活动页面“查询冒险勋章按钮”进行领取</p>
      </li>
      <li>
        <h3>4、如何查询中国移动积分？</h3>
        <p>编辑短信内容“JF”发送到10086（发送及接受短信免费），根据短信提示查询自己当前所拥有的积分，如积分为0，可能是未开通积分计划，详情请播打10086咨询。</p>
      </li>
    </ol>
  </el-dialog>
</template>

<script>
  export default {
    name: "Modal",
    props: {
      mState: Boolean
    },
    data () {
      return {
        state: false
      }
    },
    methods: {
      closeFn () {
        this.$emit('closeModal',false)
      }
    },
  }
</script>

<style scoped>
  ol li {

    margin: 10px 0;
  }
  p {
    line-height: 1.75;
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue